import styled from "styled-components";

export const Container = styled.div` 
    display: flex;
    flex-direction:column;
    gap: 20px;
    margin-top: 30px ;

`

export const Wrapper = styled.div`
  border: 1px solid #ced4da;
  border-radius: 5px;
`; 